import { fromJS } from "immutable"
import {
  GET_RECIPIENTS_SUMMARY_WATCHER,
  GET_RECIPIENTS_SUMMARY_SUCCESS,
  GET_RECIPIENTS_SUMMARY_FAILED,
  SAVE_EXCEL_RECIPIENTS_PROGRESS,
  SAVE_EXCEL_RECIPIENTS_WATCHER,
} from "./constants"

export const initialState = fromJS({})

export default function recipientsSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_EXCEL_RECIPIENTS_WATCHER:
      return state.set("percentage", 0)
    case SAVE_EXCEL_RECIPIENTS_PROGRESS:
      return state.set("percentage", action.payload)

    case GET_RECIPIENTS_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_RECIPIENTS_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_RECIPIENTS_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    default:
      return state
  }
}
